module.exports = {template: '<svg width="303" height="107" viewBox="0 0 303 107" xmlns="http://www.w3.org/2000/svg"><path d="M106.882.714H53.47v17.709H35.648v17.72H17.83v17.714H0v17.709h35.647v17.72h17.824V107H71.3V89.286h17.817v-17.72h35.653v17.72H178.242v-17.72h35.64v17.72h17.83V107h17.817V89.286h17.824v-17.72H303V53.857h-17.818V36.143h-17.83v-17.72H249.53V.714h-53.47z" fill="#F8008E" fill-rule="evenodd"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./static/svg/raw/email_monster.svg
// module id = 1052
// module chunks = 1 2 3